import { CarmResources, GroupTypes } from '@carm/_core';
import { IApplicationFeatureSection } from '@carm/_utils/models';
import { RoutesConst } from './const-routes';

export const setupMyPortalSections: IApplicationFeatureSection[] = [
    {
        localizationKey: 'application_features.accountsAndProfiles.sections.personalProfile',
        path: RoutesConst.AccountProfile_PersonalProfile,
        dataCy: 'personal-profile-section',
        acl: [
          {
            resource: CarmResources.PERSONAL_PROFILE,
            group: GroupTypes.Reader,
            isNativeAcl: true,
          },
        ],
        bottomDivider: true
    },
    {
      localizationKey: 'application_features.setupMyPortal.sections.manageMyEmployees',
      path: RoutesConst.EmployeeAccessMgt_ManageEmployees,
      dataCy: 'manage-my-employess-section',
      acl: [
        {
          resource: CarmResources.EMPLOYEE,
          group: GroupTypes.Reader,
          isNativeAcl: true,
        },
      ],
    },
    {
      localizationKey: 'application_features.setupMyPortal.sections.manageMyBusinessRelationships',
      path: RoutesConst.BusinessAccessMgt_ManageRelationship,
      dataCy: 'manage-business-relationships-section',
      acl: [
        {
          resource: CarmResources.MANAGE_RELATIONSHIPS,
          group: GroupTypes.Reader,
          isNativeAcl: true,
        },
        {
          resource: CarmResources.DOA,
          group: GroupTypes.Reader,
          isNativeAcl: true,
        },
      ],
    },
    {
      localizationKey: 'application_features.setupMyPortal.sections.manageMyClientGroups',
      path: RoutesConst.ClientGroups,
      dataCy: 'manage-my-client-groups-section',
      acl: [
        {
          resource: CarmResources.CLIENT_GROUPS,
          group: GroupTypes.Reader,
          isNativeAcl: true,
        },
      ],
    },
    {
      localizationKey: 'application_features.setupMyPortal.sections.enrollCBSAProgram',
      path: RoutesConst.CbsaProgramEnrolments,
      dataCy: 'enroll-cbsa-program-section',
      acl: [{
        resource: CarmResources.PROGRAM_ENROLMENT,
        group: GroupTypes.Reader,
        isNativeAcl: true,
      }],
      topDivider: true
    },
    {
      localizationKey: 'application_features.setupMyPortal.sections.viewApiKey',
      path: RoutesConst.ViewAPIKey,
      dataCy: 'view-api-key-section',
      acl: [
        {
          resource: CarmResources.API,
          group: GroupTypes.Reader,
          isNativeAcl: true,
        }
      ],
      topDivider: true
    },
];


export const setupPortalFeature = {
  path: RoutesConst.BusinessAccessMgt,
  localizationKey: 'application_features.setupMyPortal',
  dataCy: 'setup-my-portal-feature',
  acl: [
    {
      resource: CarmResources.EMPLOYEE,
      group: GroupTypes.Reader,
      isNativeAcl: true,
    },
    {
      resource: CarmResources.MANAGE_RELATIONSHIPS,
      group: GroupTypes.Reader,
      isNativeAcl: true,
    },
    {
      resource: CarmResources.CLIENT_GROUPS,
      group: GroupTypes.Reader,
      isNativeAcl: true,
    },
    {
      resource: CarmResources.API,
      group: GroupTypes.Reader,
      isNativeAcl: true,
    },
    {
      resource: CarmResources.PROGRAM_ENROLMENT,
      group: GroupTypes.Reader,
      isNativeAcl: true,
    },
    {
      resource: CarmResources.DOA,
      group: GroupTypes.Reader,
      isNativeAcl: true,
    },
  ],
  numberOfColumns: 2,
  sections: [
    {
      localizationKey: 'manageMyEmployees',
      path: RoutesConst.EmployeeAccessMgt_ManageEmployees,
      dataCy: 'setup-manage-my-employees-section',
      acl: [
        {
          resource: CarmResources.EMPLOYEE,
          group: GroupTypes.Reader,
          isNativeAcl: true,
        },
      ],
      columnPosition: 1,
    },
    {
      localizationKey: 'manageMyBusinessRelationships',
      path: RoutesConst.BusinessAccessMgt_ManageRelationship,
      dataCy: 'setup-manage-my-business-relationships-section',
      acl: [
        {
          resource: CarmResources.MANAGE_RELATIONSHIPS,
          group: GroupTypes.Reader,
          isNativeAcl: true,
        },
        {
          resource: CarmResources.DOA,
          group: GroupTypes.Reader,
          isNativeAcl: true,
        },
      ],
      columnPosition: 1,
    },
    {
      localizationKey: 'manageMyClientGroups',
      path: RoutesConst.ClientGroups,
      dataCy: 'setup-manage-my-client-groups-section',
      acl: [
        {
          resource: CarmResources.CLIENT_GROUPS,
          group: GroupTypes.Reader,
          isNativeAcl: true,
        },
      ],
      columnPosition: 1,
    },
    {
      localizationKey: 'viewApiKey',
      path: RoutesConst.ViewAPIKey,
      dataCy: 'setup-view-api-key-section',
      acl: [
        {
          resource: CarmResources.API,
          group: GroupTypes.Reader,
          isNativeAcl: true,
        }
      ],
      columnPosition: 1,
    },
    {
      localizationKey: 'enrollCBSAProgram',
      path: RoutesConst.CbsaProgramEnrolments,
      dataCy: 'setup-enroll-cbsa-program-section',
      acl: [{
        resource: CarmResources.PROGRAM_ENROLMENT,
        group: GroupTypes.Reader,
        isNativeAcl: true,
      }],
      columnPosition: 2,
    },
  ],
};
